import { render, staticRenderFns } from "./AccountTemplates.vue?vue&type=template&id=a4773ffa&"
import script from "./AccountTemplates.vue?vue&type=script&lang=js&"
export * from "./AccountTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AccountTemplates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports